import {useTranslation} from '@/translations/i18n'
import {InputSelectUser, UserSmallSelection} from '@/features/users/components/input-select-user/InputSelectUser'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardConsultantSearchParams} from '../../types'
import {useGetUser} from '@/features/users/queries/useGetUser'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'

export const DashboardUserFilter = () => {
    const {t} = useTranslation()
    const {searchParams, setSearchParams} = useParsedSearchParams(DashboardConsultantSearchParams)
    const {data: selectedUser, isLoading: isSelectedUserLoading} = useGetUser({
        userId: searchParams.consultant,
        responseType: 'small',
        options: {enabled: !!searchParams.consultant}
    })

    const handleChange = (user: UserSmallSelection | null) => {
        setSearchParams({consultant: user?.id})
    }

    const handleClear = () => {
        setSearchParams({consultant: undefined, startDate: undefined, endDate: undefined})
    }

    return (
        <div style={{minWidth: '200px'}}>
            <InputSelectUser
                value={selectedUser ?? null}
                onChange={handleChange}
                placeholder={t('agenda:select_consultant_placeholder')}
                isLoading={isSelectedUserLoading}
                onClear={handleClear}
                displayValue={() => {
                    return (
                        <Flexbox gap={1}>
                            <Text palette="neutral" shade="600" size="textSm">
                                {t('commons:consultant')}:
                            </Text>
                            <Text palette="neutral" shade="950" size="textSm" weight={500}>
                                {selectedUser?.fullName}
                            </Text>
                            <Text palette="neutral" shade="600" size="textSm" weight={500}>
                                ({selectedUser?.specializationName})
                            </Text>
                        </Flexbox>
                    )
                }}
                filters={{
                    status: 'operative',
                    contractType: 'flat_rate'
                }}
            />
        </div>
    )
}
